<template>
  <q-layout
    view="hHh lpr lff"
    bordered
    class="shadow-2"
  >
    <q-page-container>
      <q-page class="vonix-font bg-white">
        <div class="column no-wrap bg-white offer-screen">
          <div class="col-auto">
            <div class="row no-wrap items-center bg-grey-2 q-py-xs q-px-sm">
              <div
                class="col-auto q-pr-sm"
                style="height: 24px"
              >
                <VonixLogo class="logo" />
              </div>

              <div class="col label-title">
                Atendimento {{ getChannelAttendance() }}
              </div>
            </div>
          </div>

          <div class="col q-px-sm">
            <div
              class="row no-wrap full-height full-width items-center"
              style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            >
              <div class="col">
                <div :class="['column no-wrap', isMail ? 'reverse' : '']">
                  <div
                    class="col-auto q-pb-xs label-contactName ellipsis q-mt-xs"
                    v-if="contactName"
                  >
                    <span :class="!isMail ? 'bold' : 'text-caption'">
                      {{ contactName }}
                    </span>
                    <small
                      v-if="channel === 'TEXT'"
                      :class="{ 'no-select': isAnonymizationEnabled }"
                    >
                      - {{ displayPhone(sourceId || attendance.contact || '') }}
                      <q-tooltip v-if="isAnonymizationEnabled">
                        Número anonimizado por política de segurança
                      </q-tooltip>
                    </small>
                  </div>

                  <div
                    class="col label-contact"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  >
                    <span
                      v-if="channel === 'VOICE'"
                      :class="{ 'no-select': isAnonymizationEnabled }"
                    >
                      {{ displayPhone(contact) }}
                      <q-tooltip v-if="isAnonymizationEnabled">
                        Número anonimizado por política de segurança
                      </q-tooltip>
                    </span>

                    <div v-else>
                      <div class="column no-wrap">
                        <div
                          class="col-auto ellipsis q-mb-xs"
                          v-for="{ id, message } in messages"
                          :key="id"
                        >
                          <span
                            v-if="!isMail"
                            class="bold"
                          >
                            Diz
                          </span>
                          {{ getMessage(message) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-auto full-height column justify-around">
                <div
                  class="col-auto cursor-pointer"
                  @click="handleAnswerAttendance(true)"
                >
                  <AcceptIcon />
                  <q-tooltip dense>
                    Atender
                  </q-tooltip>
                </div>

                <div
                  class="col-auto q-mb-xs cursor-pointer"
                  @click="handleAnswerAttendance(false)"
                >
                  <RejectIcon />
                  <q-tooltip dense>
                    Rejeitar
                  </q-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import VonixLogo from '@/assets/icons/vonixLogo.svg'
import AcceptIcon from '@/assets/icons/acceptIcon.svg'
import RejectIcon from '@/assets/icons/rejectIcon.svg'
import { anonymizePhone } from './utils/phones'

export default {
  components: {
    VonixLogo,
    AcceptIcon,
    RejectIcon
  },

  data () {
    return { attendance: {} }
  },

  mounted () {
    const { attendanceId } = this.$route.params
    const attendance = sessionStorage.getItem(`attendance-${attendanceId}`)

    if (attendance) {
      this.attendance = JSON.parse(attendance)
      sessionStorage.removeItem(`attendance-${attendanceId}`)
    }
  },

  computed: {
    sourceId () {
      return this.attendance.sourceId
    },

    contact () {
      return this.attendance.contact
    },

    isMail () {
      return this.channel === 'MAIL'
    },

    messages () {
      const { messages } = this.attendance
      return Array.isArray(messages) ? messages : []
    },

    contactName () {
      return this.attendance.contactName
    },

    queueName () {
      return this.attendance.queueName ?? this.attendance.queue ?? this.attendance.queueId ?? ''
    },

    channel () {
      return this.attendance.channel
    },

    queueId () {
      return this.attendance.queueId ?? this.attendance.queue
    },

    isAnonymizationEnabled () {
      return this.attendance.anonymizePhone === true
    }
  },

  methods: {
    getMessage (message) {
      if (this.channel === 'MAIL') return message
      try {
        JSON.parse(message)
        return 'Anexo'
      } catch {
        return message.translate()
      }
    },

    getChannelAttendance () {
      if (this.channel === 'MAIL') return 'de E-mail'
      if (this.channel === 'VOICE') return 'de Voz'
      if (this.channel === 'TEXT') return 'de Chat'
      return ''
    },

    handleAnswerAttendance (accepted) {
      accepted
        ? window.parent.opener.postMessage({ attendance: this.attendance, accepted }, window.location.origin)
        : window.parent.opener.postMessage({ attendance: this.attendance, accepted: false }, window.location.origin)

      this.clearData()
    },

    clearData () {
      this.attendance = {}
    },

    displayPhone (phone) {
      if (!phone) return phone
      if (this.isAnonymizationEnabled) return anonymizePhone(phone)
      return phone
    }
  }
}

</script>

<style lang="sass">
  .vonix-font
    font-family: Roboto
    font-style: normal
    .bold
      font-weight: 500

    .offer-screen
      width: 100vw
      height: 100vh

      .logo
        width: 19px
        height: 24px

      .label-title
        font-weight: normal
        font-size: 13px
        line-height: 15px
        color: #263238

      .label-contactName
        font-size: 14px
        line-height: 16px
        color: #263238

      .label-contact
        font-weight: normal
        font-size: 14px
        line-height: 16px
        color: #263238

      .no-select
        user-select: none
        -webkit-user-select: none
        -moz-user-select: none
        -ms-user-select: none
</style>
